/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchAuditUserResponse } from './search-audit-user-response';
import { SearchAuditFieldResponse } from './search-audit-field-response';


export interface SearchAuditResponse { 
    id: string;
    user: SearchAuditUserResponse;
    entityId: string;
    entityType: string;
    entitySnapshot?: string | null;
    entityChangedDate: string;
    action: string;
    children?: Array<SearchAuditResponse> | null;
    fieldChanges?: Array<SearchAuditFieldResponse> | null;
}

